import 'prometheus.aaa.scss';
import 'prometheus.modern.scss';

import './theme.aaa.scss';
import './theme.modern.scss';

import { registerDocumentClickBubblingOnTop } from '@itslearning/atlas/frames/IframeClickEventHelper';
import { sendDocumentTitleToParent } from '@itslearning/atlas/frames/IFrameTitleUtils';

import App from './lib/App/App.svelte';

// @ts-ignore
const data = window.EPortfolioAppData;

registerDocumentClickBubblingOnTop();
sendDocumentTitleToParent(data.terms.ePortfolio);

const app = new App({
    target: document.getElementById('eportfolio-app'),
    props: data
});

export default app;
